<template>
  <container :class="['page-wrapper']">
    <flex :spacing="3">
      <flex-col :span="24">
        <test-toolbar>
          <checkbox label-size="xs" :icon-color="$root.$colors.primary" :label="$lang.dense" :icon-color-lightness="$root.$colors.bgColorLightness" v-model="dense" />
        </test-toolbar>
      </flex-col>
      <flex-col :span="24" v-for="(table, index) in tables" :key="index">
        <h-three :title="table.title" />
        <data-table
          @row-selection="onRowSelection($event)"
          @row-click="onRowClick($event)"
          @input="onInput($event)"
          :dark="$root.dark"
          :expandableRows="table.expandableRows"
          :editable-columns="table.editableColumns"
          :height="table.height"
          :color="$root.$colors.primary"
          :color-lightness="$root.$colors.bgColorLightness"
          :searchable-label="table.searchableLabel || 'Filter rows...'"
          :search-in-options="table.searchInOptions"
          :search-in="table.searchIn"
          :searchable="table.searchable"
          :selectable-rows="table.selectableRows"
          :single-selectable-rows="table.singleSelectableRows"
          :dense="dense"
          :flags-dir="flagsDir"
          :headers="table.headers"
          :items="table.items">
          <template v-slot:btn="slotProps">
            <btn color="white" :color-lightness="null" :bg-color="$root.$colors.primary" :bg-color-lightness="$root.$colors.bgColorLightness" size="sm" @click="handleClick(slotProps, 'btn')">{{ slotProps.text }}</btn>
          </template>
          <template v-slot:avatar="slotProps">
            <avatar :bg-color="$root.$colors.primary" :bg-color-lightness="$root.$colors.bgColorLightness" :text="slotProps.text" @click="handleClick(slotProps, 'avatar')" :class="['cursor-pointer']" />
          </template>
          <template v-slot:icon="slotProps">
            <icon :color="$root.$colors.primary" :color-lightness="$root.$colors.bgColorLightness" :name="slotProps.icon" @click="handleClick(slotProps, 'icon')" :class="['cursor-pointer']" />
          </template>
          <template v-slot:flag="slotProps">
            <flag :flags-dir="`${$root.config.staticAssetsDir}/flags`" :code="slotProps.code" @click="handleClick(slotProps, 'flag')" :class="['cursor-pointer']" />
          </template>
          <template v-slot:dropdown="slotProps">
            <dropdown :color="$root.$colors.primary" :color-lightness="$root.$colors.bgColorLightness" v-model="dropdown.model" :items="dropdown.items" />
          </template>
          <template v-slot:router-link="slotProps">
            <router-link :to="slotProps.to" :class="['underline']">{{ slotProps.to }}</router-link>
          </template>
          <template v-slot:a="slotProps">
            <a :href="slotProps.href" target="_blank" :class="['underline']">{{ slotProps.text }}</a>
          </template>
          <template v-slot:chip="slotProps">
            <chip color="white" :color-lightness="null" :bg-color="$root.$colors.primary" :bg-color-lightness="$root.$colors.bgColorLightness" v-for="(item, index) in slotProps.items" :key="index" v-model="chip">{{ item }}</chip>
          </template>
          <template v-slot:lazy-image="slotProps">
            <lazy-image :class="['shadow-lg']" :src="`${$root.config.staticAssetsDir}/images/guitars/strandberg-boden-prog-7/image-01.jpg`" />
          </template>
          <template v-slot:radio-group="slotProps">
            <radio-group :name="slotProps.name" v-model="radios.model">
              <radio :label-color="$dark ? 'white' : 'black'" :label-color-lightness="null" :icon-color="$root.$colors.primary" :icon-color-lightness="$root.$colors.bgColorLightness" :value="radio" v-for="(radio, index) in radios.items" :key="index" :label="radio" />
            </radio-group>
          </template>
        </data-table>
      </flex-col>
      <flex-col :span="24" v-if="friends.ready">
        <h-three :title="$lang.paginationFilteringSorting" />
        <flex-col :span="24" v-if="friends.ready">
          <paragraph v-html="$lang.episodes('Friends', friends.items.length, '__all__')" :class="['py-4']" />
          <data-table @row-selection="onRowSelection($event)" @row-click="onRowClick($event)" @input="onInput($event)" :searchable-label="$lang.searchInAllColumns" :dense="dense" :height="scrollHeight" :color="$root.$colors.primary" :color-lightness="$root.$colors.bgColorLightness" :label="$lang.selected" :items-per-page="10" search-in="__all__" :searchable="true" :headers="friends.headers" :items="friends.items" />
        </flex-col>
      </flex-col>
      <flex-col :span="24" v-if="perfectStrangers.ready">
        <paragraph v-html="$lang.episodes('Perfect Strangers', perfectStrangers.items.length, '__all__')" :class="['py-4']" />
        <data-table @row-selection="onRowSelection($event)" @row-click="onRowClick($event)" @input="onInput($event)" :searchable-label="$lang.searchInAllColumns" :dense="dense" :height="scrollHeight" :color="$root.$colors.primary" :color-lightness="$root.$colors.bgColorLightness"  :items-per-page="10" search-in="__all__" :searchable="true" :headers="perfectStrangers.headers" :items="perfectStrangers.items" />
      </flex-col>
      <flex-col :span="24" v-if="theBoldAndTheBeautiful.ready">
        <paragraph v-html="$lang.episodes('The Bold and the Beautiful', theBoldAndTheBeautiful.items.length, '__all__')" :class="['py-4']" />
        <data-table items-per-page-dropdown-direction="up" @row-selection="onRowSelection($event)" @row-click="onRowClick($event)" @input="onInput($event)" :searchable-label="$lang.searchInAllColumns" :dense="dense" :height="scrollHeight" :color="$root.$colors.primary" :color-lightness="$root.$colors.bgColorLightness"  :items-per-page="10" search-in="__all__" :searchable="true" :headers="theBoldAndTheBeautiful.headers" :items="theBoldAndTheBeautiful.items" />
      </flex-col>
    </flex>
  </container>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'PageDataTable',
  mixins: [
    methods
  ],
  data () {
    return {
      tables: [],
      dense: false,
      chip: true,
      scrollHeight: '320px',
      flagsDir: `${this.$root.config.staticAssetsDir}/flags`,
      theBoldAndTheBeautiful: {},
      friends: {},
      perfectStrangers: {},
      radios: {
        model: 'vue',
        items: ['angular', 'react', 'vue']
      },
      dropdown: {
        model: [0],
        items: Array.from(Array(20).keys()).map(value => {
          return {
            value,
            text: value
          }
        })
      }
    }
  },
  mounted () {
    this.getExternalData('data-table.json', 'tables')
    this.getExternalData('data-table-the-bold-and-the-beautiful.json', 'theBoldAndTheBeautiful', 'GET', () => {
      this.processEpisodesData('theBoldAndTheBeautiful')
    })
    this.getExternalData('data-table-perfect-strangers.json', 'perfectStrangers', 'GET', () => {
      this.processEpisodesData('perfectStrangers')
    })
    this.getExternalData('data-table-friends.json', 'friends', 'GET', () => {
      this.processEpisodesData('friends')
    })
  },
  methods: {
    processEpisodesData (series) {
      this[series] = {
        headers: [],
        items: this[series]._embedded.episodes
      }
      this[series].headers = this.createHeaders(this[series].items[0])
      this[series].ready = true
    },
    createHeaders (items) {
      const headers = []
      Object.keys(items).forEach(item => {
        if (['id', 'airtime', 'name', 'number', 'runtime', 'season'].includes(item)) {
          headers.push({
            text: item.toUpperCase(),
            value: item
          })
        }
      })
      return headers
    },
    onRowSelection ($event) {
      this.log('row-selection', 'data-table', $event)
    },
    onRowClick ($event) {
      this.log('row-click', 'data-table', $event)
    },
    onInput ($event) {
      this.log('input', 'data-table', $event)
    },
    handleClick ($data, component) {
      this.log('click', component, $data)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/ui/data-table.vue